import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import React from 'react';

const Hero = () => {
  return (
    <Container id="hero">
      <Box sx={{ height: 400, my: 5 }}>
        <Box
          component={'img'}
          src={
            'https://cdn.pixabay.com/photo/2018/03/21/15/04/regulation-3246979_960_720.jpg'
          }
          sx={{
            width: '100%',
            height: '100%',
          }}
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Box sx={{ display: 'flex', justifyContent: 'left' }}>
          <Box>
            <Typography
              variant="h3"
              sx={{ fontWeight: 600, textAlign: 'left', my: 2 }}
            >
              Data Deletion Request
            </Typography>
            <Typography variant="h6" sx={{ textAlign: 'left', my: 2 }}>
              Last updated June 11, 2025
            </Typography>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 400,
                textAlign: 'left',
                my: 2,
                color: 'text.secondary',
              }}
            >
              At Topibro Technologies, we respect your right to control your
              personal data. If you would like to request the deletion of your
              personal data from our systems, please follow the steps outlined
              below.
            </Typography>
          </Box>
        </Box>
      </Box>
    </Container>
  );
};

export default Hero;
